export const getProjectsData = (t) => {
  const makeBody = (key) =>
    t(key)
      .split('\n\n')
      .map((paragraph) => paragraph.trim())
      .filter(Boolean);

  return [
    {
      id: 'meditation-wellness',
      slug: 'meditation-wellness',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&h=800&fit=crop',
      title: t('project_meditation_title'),
      category: t('project_meditation_category'),
      intro: t('project_detail_meditation_intro'),
      body: makeBody('project_detail_meditation_body'),
      stats: [
        {
          label: t('project_detail_meditation_stat_1_label'),
          value: t('project_detail_meditation_stat_1_value')
        },
        {
          label: t('project_detail_meditation_stat_2_label'),
          value: t('project_detail_meditation_stat_2_value')
        }
      ]
    },
    {
      id: 'community-education',
      slug: 'community-education',
      image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=1200&h=800&fit=crop',
      title: t('project_education_title'),
      category: t('project_education_category'),
      intro: t('project_detail_education_intro'),
      body: makeBody('project_detail_education_body'),
      stats: [
        {
          label: t('project_detail_education_stat_1_label'),
          value: t('project_detail_education_stat_1_value')
        },
        {
          label: t('project_detail_education_stat_2_label'),
          value: t('project_detail_education_stat_2_value')
        }
      ]
    },
    {
      id: 'women-skill-development',
      slug: 'women-skill-development',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=800&fit=crop',
      title: t('project_women_empowerment_title'),
      category: t('project_women_empowerment_category'),
      intro: t('project_detail_empowerment_intro'),
      body: makeBody('project_detail_empowerment_body'),
      stats: [
        {
          label: t('project_detail_empowerment_stat_1_label'),
          value: t('project_detail_empowerment_stat_1_value')
        },
        {
          label: t('project_detail_empowerment_stat_2_label'),
          value: t('project_detail_empowerment_stat_2_value')
        }
      ]
    },
    {
      id: 'youth-leadership',
      slug: 'youth-leadership',
      image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&h=800&fit=crop',
      title: t('project_youth_leadership_title'),
      category: t('project_education_category'),
      intro: t('project_detail_youth_intro'),
      body: makeBody('project_detail_youth_body'),
      stats: [
        {
          label: t('project_detail_youth_stat_1_label'),
          value: t('project_detail_youth_stat_1_value')
        },
        {
          label: t('project_detail_youth_stat_2_label'),
          value: t('project_detail_youth_stat_2_value')
        }
      ]
    },
    {
      id: 'child-support-care',
      slug: 'child-support-care',
      image: 'https://images.unsplash.com/photo-1500099817043-86d46000d58f?w=1200&h=800&fit=crop',
      title: t('project_child_care_title'),
      category: t('project_child_care_category'),
      intro: t('project_detail_child_intro'),
      body: makeBody('project_detail_child_body'),
      stats: [
        {
          label: t('project_detail_child_stat_1_label'),
          value: t('project_detail_child_stat_1_value')
        },
        {
          label: t('project_detail_child_stat_2_label'),
          value: t('project_detail_child_stat_2_value')
        }
      ]
    }
  ];
};
